const COLUMNS_GROUPS = [
  {
    id: "expenseaccount",
    label: "Expense Account",
    widget: "link",
    width: 200
  }, {
    id: "vendorname",
    label: "Vendor Name",
    widget: "text",
    width: 200
  },{
    id: "reference",
    label: "Reference",
    widget: "number",
    width: 100
  },
  {
    id: "date",
    label: "Date",
    widget: "number",
    width: 100
  },
  {
    id: "paidthrough",
    label: "Paid Through",
    widget: "number",
    width: 200
  },
  {
    id: "customername",
    label: "Customer Name",
    widget: "text",
    width: 300
  },
  {
    id: "amount",
    label: "payables",
    widget: "number",
    width: 100
  },
  {
    id: "status",
    label: "Status",
    widget: "status",
    width: 100

  }
];

const ROW_ACTIONS=[
  {
    expenseaccount: "Office Supplies",
    vendorname: "ABC Stationery Pvt Ltd",
    reference: "EXP-2025-001",
    date: "2025-02-10",
    paidthrough: "HDFC Bank",
    customername: "Internal Operations",
    amount: "2500",
    status: "Paid"
  },
  {
    expenseaccount: "Travel Expense",
    vendorname: "Ola Cabs",
    reference: "EXP-2025-002",
    date: "2025-02-11",
    paidthrough: "UPI",
    customername: "Client Meeting",
    amount: "860",
    status: "Pending"
  },
  {
    expenseaccount: "Software Subscription",
    vendorname: "Adobe",
    reference: "EXP-2025-003",
    date: "2025-02-12",
    paidthrough: "Credit Card",
    customername: "Design Team",
    amount: "4200",
    status: "Paid"
  }
];


export {COLUMNS_GROUPS, ROW_ACTIONS};
